<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Kuis" @back="back">
            <br>
            <a-card type="inner" size="small" bordered>
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Modul">
                                <strong>{{ material ? material.category.modul.name : '' }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Kategori">
                                <strong>{{ material ? material.category.name : '' }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Materi">
                                <strong>{{ material ? material.name : '' }}</strong>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>
            <template #footer>
                <a-menu mode="horizontal" :selected-keys="[ current ]">
                    <a-menu-item v-for="item in navigation" :key="item.route">
                        <a :href="routeUri(item.route, { exam: exam.id }) + '?h=' + prevUrl">
                            <a-icon :type="item.icon"/>
                            {{ item.text }}
                        </a>
                    </a-menu-item>
                </a-menu>
            </template>
        </a-page-header>
        <slot name="exam-content"></slot>
    </div>
</template>

<script>
const tabNav = [
    {
        route: 'admin.classical.material.exam.questions.list',
        icon: 'check-square',
        text: 'Soal'
    },
    // {
    //     route: '#',
    //     icon: 'schedule',
    //     text: 'Sesi'
    // }
]

export default {
    props: {
        exam: {
            type: Object
        },
        material: {
            type: Object
        }
    },
    data() {
        return {
            tabNav
        }
    },
    computed: {
        navigation() {
            return tabNav
        },
        current() {
            return this.getRoute()
        },
        prevUrl() {
            return window.location.search.replace("?h=", '')
        }
    },
    created() {

    },
    methods: {
        back() {
            window.location.href = this.routeUri('admin.classical.material')
        },
        callback(key) {
            console.log(key);
        }
    },
}
</script>
